// Matches the same character set as usernames (Profile.jsx's USERNAME_REGEX
// is /^[a-z0-9._]{3,20}$/) — uppercase is still allowed here since this only
// has to recognize a mention token as typed; extractMentions below
// lowercases it before it's ever used to look a user up. The leading
// lookbehind stops an email address someone typed in a caption
// ("me@gmail.com") from having its domain read as a mention — word
// characters only, not ".", since a period is a normal sentence/word
// boundary (e.g. "Loved it.@amanpreet_k thanks!") and excluding it too
// would reject a real mention that just happens to follow one with no
// space. Deliberately open-ended otherwise (no length cap, no attempt to
// stop before a trailing dot) — encoding both "not too long" and "doesn't
// end on a sentence-ending dot" as lookaheads fought each other, since a
// lone trailing dot followed by nothing else looks, to a naive lookahead,
// like the run "continuing". Simpler to match generously here and let
// extractMentions trim and validate the result below.
export const MENTION_REGEX = /(?<![a-zA-Z0-9_])@[a-zA-Z0-9_.]+/g;

// Pulls just the @mentions out of a caption/comment, e.g.
// "Thanks @Amanpreet_k for the idea!" -> ["amanpreet_k"]
// "Thanks @Amanpreet_k." (a mention ending a sentence) -> ["amanpreet_k"],
// not ["amanpreet_k."] — a trailing "." can't actually be part of a
// username, so it reads as punctuation instead.
export function extractMentions(text) {
  if (!text) return [];

  const matches = text.match(MENTION_REGEX) || [];
  return [...new Set(
    matches
      .map(m => m.slice(1).replace(/\.+$/, "").toLowerCase())
      .filter(m => m.length >= 3 && m.length <= 20)
  )];
}
